var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProhibit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e31926"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prohibit",
    d: "M31,6A25,25,0,1,0,56,31,25.028,25.028,0,0,0,31,6Zm0,6.731a18.039,18.039,0,0,1,10.388,3.258l-25.4,25.4A18.046,18.046,0,0,1,12.731,31,18.289,18.289,0,0,1,31,12.731Zm0,36.538a18.039,18.039,0,0,1-10.388-3.258l25.4-25.4A18.046,18.046,0,0,1,49.269,31,18.289,18.289,0,0,1,31,49.269Z",
    transform: "translate(-6 -6)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProhibit);
export default __webpack_public_path__ + "static/media/prohibit.2f756be855d6bc1cbf6fb4661e1be6c8.svg";
export { ForwardRef as ReactComponent };